import gql from 'graphql-tag'

//query
const allCategories = () => gql`
  {
    categorias(filter: {page_size: 100, page_number: 1}) {
      items {
        id
        nome
        descricao
      }
      page_info {
        current_page
        has_next
        has_previous
        page_size
      }
    }
  }
`

export { allCategories }
